<template>
  <div v-show="isFullHeader" class="header-full-menu-wrapper">
    <!-- 第一層 MENU 靠左 -->
    <div class="full-menu-left">
      <template v-for="item in MENU" :key="item.functionId + '_FULL'">
        <!-- 第一層MENU (有子選單) -->
        <div v-if="item.children" class="menu-item-wrapper" @mouseover="menuMouseover(item.functionId)"
          @mouseleave="menuMouseleave">
          <template v-if="hasRoute(item.functionId)">
            <router-link :to="{ name: item.functionId }" custom v-slot="{ href, navigate }">
              <div role="button" class="menu-item" :class="{ active: checkActive(item.functionId) }"
                @click="subLink($event, navigate, item)">
                <a :href="href" :id="item.functionId">
                  {{ item.menuText }}
                </a>
                <span class="down-arrow" :class="{ active: checkActive(item.functionId) }"></span>
              </div>
            </router-link>
          </template>
          <template v-else>
            <div class="menu-item" :class="{ active: checkActive(item.functionId) }">
              {{ item.menuText }}
              <span class="down-arrow" :class="{ active: checkActive(item.functionId) }"></span>
            </div>
          </template>

          <!-- 第二層與第三層 MENU (貼在選項正下方、靠左對齊) -->
          <div class="sub-menu" :class="{ active: checkActive(item.functionId) }" @mouseover="subMenuMouseover"
            @mouseleave="subMenuMouseleave">
            <div class="sub-menu-group" v-for="level2Item in item.children" :key="level2Item.functionId + '_sub'"
              :id="level2Item.functionId + '_sub'">
              <template v-if="level2Item.children">
                <div class="col-12" :style="[subTitle(item)]">
                  {{ level2Item.menuText }}
                </div>
                <template v-for="level3Item in level2Item.children" :key="level3Item.functionId">
                  <template v-if="hasRoute(level3Item.functionId)">
                    <div :class="level3Class(item)">
                      <router-link :to="{ name: level3Item.functionId }" custom v-slot="{ href, navigate }">
                        <a :href="href" @click="subLink($event, navigate, level3Item)" :id="level3Item.functionId">
                          {{ level3Item.menuText }}
                        </a>
                      </router-link>
                    </div>
                  </template>
                  <template v-else>
                    <div :class="level3Class(item)">
                      {{ level3Item.menuText }}
                    </div>
                  </template>
                </template>
              </template>
              <template v-else-if="hasRoute(level2Item.functionId)">
                <div class="col-12" :style="[subTitle(item)]">
                  <router-link :to="{ name: level2Item.functionId }" custom v-slot="{ href, navigate }">
                    <a :href="href" @click="subLink($event, navigate, level2Item)" :id="level2Item.functionId">
                      {{ level2Item.menuText }}
                    </a>
                  </router-link>
                </div>
              </template>
              <template v-else>
                <div class="col-12" :style="[subTitle(item)]">
                  {{ level2Item.menuText }}
                </div>
              </template>
            </div>
          </div>
        </div>

        <!-- 第一層MENU (無子選單) -->
        <template v-else-if="hasRoute(item.functionId)">
          <router-link :to="{ name: item.functionId }" custom v-slot="{ href, navigate }">
            <div role="button" class="menu-item" :class="{ active: checkActive(item.functionId) }"
              @mouseover="menuMouseover(item.functionId)" @mouseleave="menuMouseleave" @click="navigate">
              <a :href="href" :id="item.functionId">
                {{ item.menuText }}
              </a>
            </div>
          </router-link>
        </template>
      </template>
    </div>

    <!-- 商家後台登入 & 聯絡我們 靠右 -->
    <div class="full-menu-right">
      <div class="menu-sc" role="button" @click="openSc">商家後台登入</div>
      <div role="button" class="menu-contact-us" :class="{ isCyber: isCyber }" @click="linkContactUs">
        <span>聯絡我們</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

/**
 * HeaderFullMenu (PC版頂部完整選單導覽列組件)
 *
 * 包含第一層 MENU 選項（靠左對齊）、商家後台登入與聯絡我們按鈕（靠右對齊），
 * 以及滑鼠懸浮時於選項正下方開啟、靠左對齊且尺寸自適應的二/三層下拉選單 (.sub-menu)。
 */
export default {
  name: "HeaderFullMenu",
  data() {
    const envData = this.env ? this.env.getData() : { SC_RUL: "" };
    let menuObj = {};
    if (this.MENU) {
      this.MENU.forEach((item) => {
        menuObj[item.functionId] = item;
      });
    }
    return {
      menuObj: menuObj,
      activeId: "",
      menuIsOver: false,
      subMenuIsOver: false,
      menuTimeOut: null,
      scUrl: envData.SC_RUL,
    };
  },
  props: {
    /** 選單資料結構物件 */
    MENU: {
      type: Object,
    },
  },
  components: {},
  computed: {
    /** 判斷選單是否處於展開啟動狀態 */
    active() {
      return this.menuIsOver || this.subMenuIsOver;
    },
    /** 當前 Hover 選中的第一層選單項目 */
    MenuItem() {
      let obj = this.menuObj[this.activeId];
      if (obj) {
        return obj;
      } else {
        return null;
      }
    },
    /** 當前 Hover 選單項目的第二層子選單列表 */
    level2Items() {
      let obj = this.MenuItem;
      if (obj != null && obj.children) {
        return obj.children;
      } else {
        return [];
      }
    },
    /** 判斷當前頁面是否為資安主題 (套用 Cyber 漸層樣式) */
    isCyber: function () {
      let meta = this.$route?.meta || {};
      return !!meta.isCyber;
    },
    ...mapGetters("device", {
      isFullHeader: "getIsFullHeader",
    }),
  },
  mounted: function () {
    this.initData();
  },
  methods: {
    initData: function () { },
    /** 滑鼠懸浮第一層選單 */
    menuMouseover: function (functionId) {
      this.activeId = functionId;
      this.menuIsOver = true;
      clearTimeout(this.menuTimeOut);
    },
    /** 滑鼠離開第一層選單 */
    menuMouseleave: function () {
      this.menuTimeOut = setTimeout(() => {
        this.menuIsOver = false;
      }, 150);
    },
    /** 滑鼠懸浮下拉選單區塊 */
    subMenuMouseover: function () {
      if (this.subMenuIsOver == false) {
        this.subMenuIsOver = true;
      }
      clearTimeout(this.menuTimeOut);
    },
    /** 滑鼠離開下拉選單區塊 */
    subMenuMouseleave: function () {
      this.menuTimeOut = setTimeout(() => {
        this.subMenuIsOver = false;
      }, 150);
    },
    /** 檢查該選單項目是否啟用 Hover 狀態 */
    checkActive: function (functionId) {
      return functionId == this.activeId && !!this.active;
    },
    /** 計算第三層選單項目欄位寬度 Class */
    level3Class: function (menuItem) {
      var colNum = menuItem ? menuItem.colNum : null;
      if (colNum) {
        return "col-" + 12 / colNum;
      } else {
        return "col-3";
      }
    },
    /** 點擊子選單連結 */
    subLink: function (event, navigate, item) {
      this.activeId = "";
      this.subMenuIsOver = false;
      this.menuIsOver = false;
      navigate(event);
    },
    /** 子選單標題對齊樣式 */
    subTitle: function (MenuItem) {
      return {
        "text-align": "left",
      };
    },
    /** 開啟商家後台登入頁面 */
    openSc() {
      window.open(this.scUrl, "_blank");
    },
    /** 導向聯絡我們頁面 */
    linkContactUs() {
      this.goTo({
        name: "ContactUs",
      });
    },
  },
  watch: {},
  setup(props, context) { },
};
</script>

<style scoped>
.header-full-menu-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 30px;
}

.full-menu-left {
  display: flex;
  align-items: center;
  position: relative;
}

.full-menu-right {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.full-menu-left a,
.full-menu-right a {
  color: black;
  text-decoration: none;
}

.menu-item-wrapper {
  position: relative;
}

.menu-item.active {
  /* 滑入後的底色 */
  background-color: #f5f5f5;
}

.menu-item {
  border-radius: 10px;
  padding: 10px 20px 10px 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 10px;
}

.menu-sc {
  border-radius: 10px;
  margin-left: 0;
  margin-right: 15px;
  padding: 10px 10px 10px 10px;
  color: var(--color-red);
  font-weight: bold;
  display: flex;
  align-items: center;
}

.menu-sc:hover {
  background-color: #f5f5f5;
}

.menu-contact-us {
  border-radius: 25px;
  margin: 4px 20px;
  padding: 10px 20px 10px 20px;
  background-color: var(--color-red);
}

.menu-contact-us>span {
  color: #ffffff;
}

.menu-contact-us.isCyber {
  background: linear-gradient(289.79deg,
      var(--cyber-color-start) var(--cyber-gradient-stop-1),
      var(--cyber-color-mid) var(--cyber-gradient-stop-2),
      var(--cyber-color-end) var(--cyber-gradient-stop-3));
}

.menu-contact-us:hover {
  background-color: #f5f5f5;
}

.menu-contact-us:hover>span {
  color: var(--color-red);
}

.menu-contact-us.isCyber:hover {
  background: #f5f5f5;
}

.menu-contact-us.isCyber:hover>span {
  display: inline-block;
  background-image: linear-gradient(289.79deg,
      var(--cyber-color-start) var(--cyber-gradient-stop-1),
      var(--cyber-color-mid) var(--cyber-gradient-stop-2),
      var(--cyber-color-end) var(--cyber-gradient-stop-3));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.sub-menu {
  align-items: flex-start;
  background-color: #fbfbfb;
  border-radius: 12px;
  padding: 1rem 0.5rem;
  top: calc(100% + 4px);
  left: 0;
  position: absolute;
  box-sizing: border-box;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  border: 1px solid #eaeaea;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-8px);
  transition: transform 0.2s ease, opacity 0.2s ease, visibility 0.2s ease;
  display: none;
  width: max-content;
  min-width: 180px;
  max-width: 820px;
  z-index: 1000;
}

.sub-menu::before {
  content: "";
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
  height: 10px;
}

.sub-menu.active {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  display: block;
}

.sub-menu-group {
  display: flex;
  flex-wrap: wrap;
  padding: 0 0.8rem 0.8rem 0.8rem;
  text-align: left;
}

.sub-menu-group>div {
  text-align: left;
}

.sub-menu-group>div:first-child {
  font-weight: 600;
  color: var(--color-red) !important;
  padding: 0px 15px;
  text-align: left;
}

.sub-menu-group a:hover {
  text-decoration: underline;
}

.sub-menu-group> :not(div:first-child) {
  padding: 10px 15px 0 15px;
}
</style>
